import React from 'react';
import { BaseComponent } from "project/general";
import { render } from "preact";
import { BaseForm, formConstants } from 'shared/base-form';
import { notificationTypes } from 'project/general';
import { notificationService } from 'project/services';
import { SearchFilters } from 'components/service-directory-search-results-page/js/filtering/search-filters.jsx';

class HeritageSearchComponent extends BaseComponent {

    static getRequiredRefs() {
        return ["secondarySearchForm", "secondarySearchResults", "secondarySearchSubmit"];
    }

    static getNamespace() {
        return 'heritage-search';
    }

    onInit() {
        this.onInitForm();
    }

    onInitForm() {

        //  Instantiate the form helper class, define submit behaviour
        this.formInstance = new BaseForm(this.refs.secondarySearchForm, {
            errorsSummary: document.getElementById("data-errors-summary"),
            submitElement: this.refs.secondarySearchSubmit,
            onSuccessfulSubmit: (response) => {

                var searchResults = response.data.data;

                if (searchResults == undefined) {
                    var message = "";
                    if (response.data.errors != undefined) { message = response.data.errors[0]; }
                    else { message = "There was a problem"; }
                    notificationService.push({
                        message: message,
                        type: notificationTypes.WARNING,
                    });
                }

                else {
                    this.renderSearchResults(searchResults);
                }

            },
            onFailedSubmit: (error) => {
                notificationService.push({
                    message: "There was an error",
                    type: notificationTypes.ERROR,
                });
            },
            enctype: formConstants.ENCTYPE_JSON
        });

    }

    renderSearchResults(searchResults) {
        render(
            <div class="asset-list" >
                <div class="asset-item">
                    <div class="asset-categories">
                        <div class="asset-category">
                            Interview
                        </div>
                        <div class="asset-category">
                            PDF
                        </div>
                    </div>
                    <h4 class="asset-title">
                        Interview with Gerald de Groot
                    </h4>
                </div>
            </div>
            ,
            this.refs.secondarySearchResults
        );
    }

   

}

export default HeritageSearchComponent;
